export const paraPhrasing = async(paraphraseingText) => {
    var formdata = new FormData();
    formdata.append("sentence", paraphraseingText);

    var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };

    let data = await fetch("http://139.59.17.33:8018/paraphrase/", requestOptions)
    if (data.status === 200) {
        const response = await data.json();
        return response.paraphrase
    }
}